<template>
  <BaseFilterDialogAndChips
    :submitted-values="submittedValues"
    :show-reset-button="showResetButton"
    @open="copyFilterParams"
    @clear:filter="clearFilter"
    @reset="resetFilters"
    @submit="submitFilters"
  >
    <v-row dense>
      <v-col cols="12" sm="6">
        <BaseDatepickerInput
          v-model="params.signed_date_from"
          :label="$t('invoices.labels.signed_from')"
        />
      </v-col>

      <v-col cols="12" sm="6">
        <BaseDatepickerInput
          v-model="params.signed_date_to"
          :label="$t('invoices.labels.signed_to')"
        />
      </v-col>

      <v-col v-if="$can(['invoices.create'])" cols="12" sm="6">
        <ContactAutocomplete
          v-model="params.client_id"
          :label="$t('general.contact')"
          @update:initial-item="updateAutocompleteValue('client_id', $event)"
        />
      </v-col>
    </v-row>
  </BaseFilterDialogAndChips>
</template>

<script>
import BaseFilterDialogAndChips from '@/components/base/BaseFilterDialogAndChips';
import BaseDatepickerInput from '@/components/base/BaseDatepickerInput';
import ContactAutocomplete from '@/components/autocompletes/ContactAutocomplete';
import filterMixin from '@/mixins/filter-mixin';
import { getDefaultInvoiceFilterParams } from '@/store/modules/invoices-module';

export default {
  name: 'InvoiceFilter',

  components: { ContactAutocomplete, BaseDatepickerInput, BaseFilterDialogAndChips },

  mixins: [filterMixin],

  data() {
    return {
      defaultParams: getDefaultInvoiceFilterParams(),
    };
  },

  computed: {
    submittedValues() {
      const values = [];
      const { signed_date_from, signed_date_to, client_id } = this.filterParams;

      if (signed_date_from) {
        values.push({
          key: 'signed_date_from',
          value: signed_date_from,
          label: this.$t('invoices.labels.signed_from'),
        });
      }

      if (signed_date_to) {
        values.push({
          key: 'signed_date_to',
          value: signed_date_to,
          label: this.$t('invoices.labels.signed_to'),
        });
      }

      if (client_id && this.autocompleteValues.client_id?.id === client_id) {
        values.push({
          key: 'client_id',
          value: this.autocompleteValues.client_id.name,
          label: this.$t('general.contact'),
        });
      }

      return values;
    },
  },
};
</script>

<style scoped></style>
